import React from 'react';
import _times from 'lodash/times';
import styled from 'styled-components';

import { ProductCardLoadingSkeleton, LoadingSkeleton } from 'components/core';
import CarouselSlider from 'components/carousel-slider';
// Imported directly from carousels.styles (not the `src/components/carousels` barrel) to avoid a
// module cycle: that barrel re-exports `custom-carousel.jsx`, which imports `carousel-v2/types/product-carousel`,
// which imports `EmptyLoadingState` -- the module that (transitively, via loading-page-states) requires this file.
import { CardCarouselItem, GroupHeader, Section } from 'src/components/carousels/carousels.styles';
import { CARD_SIZES } from 'components/product-card/product-card.constants';

const ProductSkeletonCarousel = ({ showBorder = true, ...rest }) => (
  <Section noBorder {...rest}>
    <GroupHeader>
      <LoadingSkeleton width={183} height={13} />
    </GroupHeader>
    <CarouselSlider>
      {_times(6, (key) => (
        <CardCarouselItem key={key}>
          <ProductCardLoadingSkeleton cardSize='large' dimensions={CARD_SIZES.default} />
        </CardCarouselItem>
      ))}
    </CarouselSlider>
    {showBorder && <StyledLine />}
  </Section>
);

export default ProductSkeletonCarousel;

const StyledLine = styled.hr`
  background-color: ${({ theme }) => theme.colors.blueGrey[90]};
  height: 1px;
  border: none;
  margin: 30px 0 0;
`;
